import { render, staticRenderFns } from "./CardRateAndComment.vue?vue&type=template&id=4ab15d7e&scoped=true"
import script from "./CardRateAndComment.vue?vue&type=script&lang=js"
export * from "./CardRateAndComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab15d7e",
  null
  
)

export default component.exports